import React from 'react';
import { CampaignStats } from '../types';
import { pct } from '../lib';
import NumberStrip, { StripItem } from './NumberStrip';

/** A campaign's KPI row — site visits first (the headline), then scheduled,
 *  then the delivery funnel as value · % of enrolled. One renderer for one
 *  campaign and for the sum of many. */
const StatStrip: React.FC<{ stats: CampaignStats; showDelivered?: boolean; className?: string }> = ({
  stats, showDelivered = false, className = '',
}) => {
  const items: StripItem[] = [
    { v: stats.visits_conducted, k: 'site visits', cls: 'visited' },
    { v: stats.visited, k: 'scheduled', cls: 'gold' },
    { v: stats.enrolled, k: 'enrolled', p: stats.excluded > 0 ? `${stats.excluded} excluded` : undefined },
    { v: stats.sent, k: 'sent', p: pct(stats.sent, stats.enrolled) },
    ...(showDelivered ? [{ v: stats.delivered, k: 'delivered', p: pct(stats.delivered, stats.enrolled) }] : []),
    { v: stats.read, k: 'read', p: pct(stats.read, stats.enrolled) },
    { v: stats.replied, k: 'replied', p: pct(stats.replied, stats.enrolled) },
    { v: stats.clicked, k: 'clicked', p: pct(stats.clicked, stats.enrolled) },
    ...(stats.failed > 0 ? [{ v: stats.failed, k: 'failed', p: pct(stats.failed, stats.enrolled), cls: 'bad' as const }] : []),
  ];
  return <NumberStrip items={items} className={className} />;
};

export default StatStrip;
